import React from 'react';
import { IconProps } from './IconTypes';

const UKLogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 120"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0" y="0" width="200" height="120" fill="none" stroke={color} strokeWidth="6" />
      <polygon points="0,0 30,0 200,108 200,120 170,120 0,12" />
      <polygon points="170,0 200,0 200,12 30,120 0,120 0,108" />
      <rect x="84" y="0" width="32" height="120" />
      <rect x="0" y="44" width="200" height="32" />
    </svg>
  );
};

export default UKLogo;
